import { render } from "./scStatusIndicator.vue?vue&type=template&id=5824b3ca&scoped=true"
import script from "./scStatusIndicator.vue?vue&type=script&lang=js"
export * from "./scStatusIndicator.vue?vue&type=script&lang=js"

import "./scStatusIndicator.vue?vue&type=style&index=0&id=5824b3ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5824b3ca"]])

export default __exports__